import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addOrUpdateCropMixComposerPreferences } from "services";

import { GET_CROP_MIX_COMPOSER_SETTINGS, MUTATE_CROP_MIX_COMPOSER_SETTINGS } from "consts";

export const useMutateCropMixComposerSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [MUTATE_CROP_MIX_COMPOSER_SETTINGS],
    mutationFn: addOrUpdateCropMixComposerPreferences,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_MIX_COMPOSER_SETTINGS] });
    },
  });
};
